import React from 'react';
import { Grid } from 'fw/forms';
import { Button } from 'fw/components';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import CertificationLink from 'areas/shared/components/formatter/CertificationLink';

const columns = [
	{ key: 'vobId', name: 'APP ID', width: 60, formatter: CertificationLink, getRowMetaData: (row) => row, sortable: false },
	{ key: 'daysIn', name: 'Days In', width: 75, sortable: false },
	{ key: 'requestingUser', name: 'Requesting User', width: 315, sortable: false },
	{ key: 'vobRequested', name: 'Company Requested', width: 325, sortable: false },
	{ key: 'vobOwners', name: 'Company Owner(s)', sortable: false }
];

class SearchRequestAppealGrid extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
		return {
			list: []
		};
	}

	onExportData = () => {
		const rq = Object.assign({});

		new API().post(APIModules.Admin.url('/queue/exportSearchAppealRequests'), rq,
		{
			success: (sr) => {
				new API().download(sr.data);
			}
		});
	}

	search = (rq, callback) => {
		var state = {
			list: []
		};

		new API().post(APIModules.Admin.url('/queue/searchAppealRequests'), rq,
			{
				success: (r) => {
					state = {
						list: r.data.items
					};

					this.setState(state);

					if (callback)
						callback();
				}
			});

		return state;
	}

	render() {
		return (
			<React.Fragment>
				<Grid
					ref={(c) => { this._grid = c }}
					columns={columns}
					items={this.state.list}
					height={400}
					className="table-condensed"
					rowKey="vobId"
					name="default" />
				<hr />
				<div className="btn-toolbar">
					{this.state.list &&
						<Button
							id="btnExportCsv"
							onClick={this.onExportData}
							className="btn btn-default pull-right" >
							<FontAwesomeIcon icon={faFileExport} /> Export CSV
						</Button>
					}
				</div>
			</React.Fragment>
		)
	}
}

export default SearchRequestAppealGrid;




// WEBPACK FOOTER //
// ./src/areas/admin/certification/appealRequested/SearchRequestAppealGrid.js